import { adaptiveFontSize, getMobileMaxColumnWidth } from './helpers'

const detailedDescriptionHeight = (data) => {
    const {
        parent: { lineHeight, lineCount },
        // config = {},
    } = data

    const height = lineHeight * lineCount

    return height
}

const detailedKnownHeight = (parent, config) => {
    const { description, banner, name, info } = parent
    const { displayBanner } = config
    const height =
        description.height({ parent: description }) +
        name.divider +
        name.height +
        (displayBanner ? banner.divider : 0) +
        (displayBanner ? banner.height : 0) +
        info.divider +
        info.height

    return height
}

export const DESKTOP_DETAILED_STYLES = {
    sm: {
        detailed: {
            seeAll: {
                fontSize: 15,
            },
            title: {
                fontSize: 15,
            },
            column: {
                maxWidth: 225,
            },
            utilities: {
                iconSize: 0.7,
            },
            viewers: {
                iconSize: 0.47,
                fontSize: 10,
                offsetY: 0,
            },
            badge: {
                status: {
                    iconSize: 0.5,
                    fontSize: 7,
                    offsetX: 4,
                    offsetY: 4,
                },
                newMissMFC: {
                    fontSize: 7,
                },
                priorMissMFC: {
                    height: 10.5,
                    width: 10.5,
                },
            },
            banner: {
                popular: {
                    viewers: {
                        margin: '0 4px',
                    },
                },
                trending: {
                    diff: {
                        margin: '0 2px 0 1px',
                    },
                    text: 'viewers per minute',
                },
                new: {
                    time: {
                        margin: '0 4px',
                    },
                },
                missMFC: {
                    rank: {
                        margin: '0 3px',
                    },
                },
                iconSize: 0.6,
                fontSize: 9,
                divider: 3,
                height: 20,
            },
            name: {
                fontSize: adaptiveFontSize(),
                fontSizeMinimum: 9.7,
                height: 20,
                divider: 6,
            },
            description: {
                avatar: {
                    margin: '2px 6px 0 0',
                },
                height: detailedDescriptionHeight,
                padding: '0 8px',
                lineHeight: 10.5,
                fontSize: 9.5,
                lineCount: 4,
                size: 40,
            },
            info: {
                fontSize: 7,
                divider: 6,
                height: 18,
            },
            _knownHeight: detailedKnownHeight,
        },
    },
    md: {
        detailed: {
            seeAll: {
                fontSize: 16,
            },
            title: {
                fontSize: 17,
            },
            column: {
                maxWidth: 300,
            },
            utilities: {
                iconSize: 0.8,
            },
            viewers: {
                fontSize: 10.5,
                iconSize: 0.5,
                offsetY: 0,
            },
            badge: {
                status: {
                    iconSize: 0.6,
                    fontSize: 8,
                    offsetX: 5,
                    offsetY: 5,
                },
                newMissMFC: {
                    fontSize: 8,
                },
                priorMissMFC: {
                    height: 12.5,
                    width: 12.5,
                },
            },
            banner: {
                popular: {
                    viewers: {
                        margin: '0 4px',
                    },
                },
                trending: {
                    diff: {
                        margin: '0 2px 0 1px',
                    },
                },
                new: {
                    time: {
                        margin: '0 4px',
                    },
                },
                missMFC: {
                    rank: {
                        margin: '0 3px',
                    },
                },
                iconSize: 0.6,
                fontSize: 9.4,
                divider: 2,
                height: 24,
            },
            name: {
                fontSize: adaptiveFontSize(),
                fontSizeMinimum: 12.7,
                height: 28,
                divider: 6,
            },
            description: {
                avatar: {
                    margin: '2px 8px 0 0',
                },
                height: detailedDescriptionHeight,
                padding: '0 8px',
                lineHeight: 12,
                fontSize: 11,
                lineCount: 4,
                size: 44,
            },
            info: {
                fontSize: 9,
                divider: 6,
                height: 22,
            },
            _knownHeight: detailedKnownHeight,
        },
    },
    lg: {
        detailed: {
            seeAll: {
                fontSize: 17,
            },
            title: {
                fontSize: 19,
            },
            column: {
                maxWidth: 450,
            },
            utilities: {
                iconSize: 0.9,
            },
            viewers: {
                iconSize: 0.6,
                fontSize: 12,
                offsetY: 0,
            },
            badge: {
                status: {
                    iconSize: 0.8,
                    fontSize: 9,
                    offsetX: 6,
                    offsetY: 6,
                },
                newMissMFC: {
                    fontSize: 9,
                },
                priorMissMFC: {
                    height: 16.5,
                    width: 16.5,
                },
            },
            banner: {
                popular: {
                    viewers: {
                        margin: '0 4px',
                    },
                },
                trending: {
                    diff: {
                        margin: '0 4px 0 1px',
                    },
                },
                new: {
                    time: {
                        margin: '0 4px',
                    },
                },
                missMFC: {
                    rank: {
                        margin: '0 3px',
                    },
                },
                iconSize: 0.8,
                fontSize: 14,
                divider: 1,
                height: 28,
            },
            name: {
                fontSize: adaptiveFontSize(),
                fontSizeMinimum: 18,
                height: 38,
                divider: 8,
            },
            description: {
                avatar: {
                    margin: '2px 8px 0 0',
                },
                height: detailedDescriptionHeight,
                padding: '0 8px',
                lineHeight: 13,
                fontSize: 12,
                lineCount: 4,
                size: 52,
            },
            info: {
                fontSize: 12,
                divider: 8,
                height: 28,
            },
            _knownHeight: detailedKnownHeight,
        },
    },
}

export const MOBILE_DETAILED_STYLES = {
    sm: {
        detailed: {
            seeAll: {
                fontSize: 9.5,
            },
            title: {
                fontSize: 15,
            },
            column: {
                maxWidth: getMobileMaxColumnWidth(3),
            },
            utilities: {
                iconSize: 0.5,
            },
            viewers: {
                iconSize: 0.43,
                fontSize: 9,
                offsetY: 1,
            },
            badge: {
                status: {
                    iconSize: 0.35,
                    fontSize: 6,
                    offsetX: 1,
                    offsetY: 1,
                },
                newMissMFC: {
                    fontSize: 6,
                    margin: 1,
                },
                priorMissMFC: {
                    height: 8,
                    width: 9,
                },
            },
            banner: {
                popular: {
                    viewers: {
                        margin: '0 2px',
                    },
                    text: 'room viewers',
                },
                trending: {
                    diff: {
                        margin: '0 2px 0 1px',
                    },
                    text: 'views per min',
                },
                new: {
                    time: {
                        margin: '0 2px',
                    },
                },
                missMFC: {
                    rank: {
                        margin: '0 2px',
                    },
                },
                iconSize: 0.4,
                fontSize: 7,
                divider: 2,
                height: 20,
            },
            roomIconOffset: -4,
            name: {
                fontSize: adaptiveFontSize({ fixed: true }),
                fontSizeMinimum: 9.7,
                height: 18,
                divider: 4,
            },
            description: {
                avatar: {
                    margin: '2px 4px 0 0',
                },
                height: detailedDescriptionHeight,
                padding: '0 4px',
                lineHeight: 7,
                lineCount: 4,
                fontSize: 7,
                size: 20,
            },
            info: {
                fontSize: 7,
                divider: 4,
                height: 16,
            },
            _knownHeight: detailedKnownHeight,
        },
    },
    md: {
        detailed: {
            seeAll: {
                fontSize: 12.5,
            },
            title: {
                fontSize: 16,
            },
            column: {
                maxWidth: getMobileMaxColumnWidth(2),
            },
            utilities: {
                iconSize: 0.7,
            },
            viewers: {
                iconSize: 0.43,
                fontSize: 9.5,
                offsetY: 0,
            },
            badge: {
                status: {
                    iconSize: 0.5,
                    fontSize: 7,
                    offsetX: 4,
                    offsetY: 4,
                },
                newMissMFC: {
                    fontSize: 7,
                    margin: 2,
                },
                priorMissMFC: {
                    height: 12,
                    width: 13,
                },
            },
            banner: {
                popular: {
                    viewers: {
                        margin: '0 2px',
                    },
                },
                trending: {
                    diff: {
                        margin: '0 2px 0 1px',
                    },
                    text: 'views per minute',
                },
                new: {
                    time: {
                        margin: '0 2px',
                    },
                },
                missMFC: {
                    rank: {
                        margin: '0 2px',
                    },
                },
                iconSize: 0.4,
                fontSize: 8,
                divider: 2,
                height: 24,
            },
            roomIconOffset: '0px',
            name: {
                fontSize: adaptiveFontSize({ fixed: true }),
                fontSizeMinimum: 12.7,
                height: 20,
                divider: 6,
            },
            description: {
                avatar: {
                    margin: '2px 4px 0 0',
                },
                height: detailedDescriptionHeight,
                padding: '0 6px',
                lineHeight: 9,
                lineCount: 4,
                fontSize: 8,
                size: 28,
            },
            info: {
                fontSize: 9,
                divider: 6,
                height: 18,
            },
            _knownHeight: detailedKnownHeight,
        },
    },
    lg: {
        detailed: {
            seeAll: {
                fontSize: 14,
            },
            title: {
                fontSize: 17,
            },
            column: {
                maxWidth: getMobileMaxColumnWidth(1),
            },
            utilities: {
                iconSize: 0.8,
            },
            viewers: {
                iconSize: 0.5,
                fontSize: 10.5,
                offsetY: 0,
            },
            badge: {
                status: {
                    iconSize: 0.7,
                    fontSize: 7,
                    offsetX: 5,
                    offsetY: 5,
                },
                newMissMFC: {
                    fontSize: 7,
                    margin: 3,
                },
                priorMissMFC: {
                    height: 17,
                    width: 18,
                },
            },
            banner: {
                popular: {
                    viewers: {
                        margin: '0 4px',
                    },
                },
                trending: {
                    diff: {
                        margin: '0 4px 0 2px',
                    },
                    text: 'viewers per minute',
                },
                new: {
                    time: {
                        margin: '0 4px',
                    },
                },
                missMFC: {
                    rank: {
                        margin: '0 3px',
                    },
                },
                iconSize: 0.6,
                fontSize: 9,
                divider: 1,
                height: 28,
            },
            name: {
                fontSize: adaptiveFontSize({ fixed: true }),
                fontSizeMinimum: 16.7,
                height: 32,
                divider: 8,
            },
            description: {
                avatar: {
                    margin: '2px 8px 0 0',
                },
                height: detailedDescriptionHeight,
                padding: '0 8px',
                lineHeight: 14,
                fontSize: 13,
                lineCount: 4,
                size: 48,
            },
            info: {
                fontSize: 12,
                divider: 8,
                height: 28,
            },
            _knownHeight: detailedKnownHeight,
        },
    },
}
